<template>
  <div class="home">
    <hk-header @logUserOut="activateLogout">
      <template #list-icon>
        <el-icon :size="20" @click="show_properties = !show_properties" 
            v-a11y-keyboard="{
              enter: () => show_properties = !show_properties
            }" 
            tabindex="0" 
            role="button" 
            :aria-expanded="show_properties" 
            aria-label="Toggle property list">
          <List />
        </el-icon>
      </template>
    </hk-header>
    <div v-if="logout_loading">
    <el-icon :size="40" class="is-loading">
      <Loading />
    </el-icon>
    </div>
    <el-main v-else>
      <property-list
        :active-property="selected_property"
        :show-properties="show_properties"
        @selectProperty="chooseProperty"
        @clearProperty="deSelectProperty"
        @closeProperties="show_properties = false"
      />

      <div class="content">
        <div v-if="permissions_loading" class="loading">
          <el-icon :size="20" class="is-loading">
            <Loading />
          </el-icon>
        </div>
        <div v-else id="applications" tabindex="-1">
          <enterprise-apps v-if="selected_property === null" />
          <property-apps v-else :property="selected_property" />
        </div>
      </div>
    </el-main>
    <SessionTimeoutPopup
      v-if="popupVisible"
      :timeLeftInSeconds="timeLeftSeconds"
      :meta="meta"
      :sessionInProgress="sessionInProgress"
    />
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
import mutations from '@/store/mutation_types'
import actions from '@/store/action_types'
import EnterpriseApps from '@/components/EnterpriseApps'
import PropertyApps from '@/components/PropertyApps'
import axios from 'axios'
import * as Security from '@/common/security_manager'
import { clearAllCookies, clearLocalStorage, hkTokenOrBearerToken, setCurrentTab, setCookies, getCookie, is_sharedWorker_enabled,checkPermission } from '@/common/utils'
import HkHeader from '@/components/HkHeader'
import PropertyList from '@/components/PropertyList'
import dayjs from 'dayjs'
import LoginService from '@/views/login/login.service'
import Global from '@/common/global.service'
import { initDataLog } from '@/plugins/data-dog-config.js'
import { useSharedWorkerSession, requestLogout, refreshToken, sendTokenAckToWorker, ensureTabId, setHomeURL, getHomeUrlFromRouterStrategy,notifyDisconnect ,userRequestedExtend, SessionTimeoutPopup} from '@hotelkeyrepo/hk-shared-worker-lib'
import { sendMessageToApps } from '@hotelkeyrepo/hk-shared-worker-lib';

import { RouteStore } from "@/store/routeStore.js";
import { useWorkerStore } from '@/store/workerStore.js'
export default {
  name: 'home',
  components: {
    EnterpriseApps,
    PropertyApps,
    HkHeader,
    PropertyList,
    SessionTimeoutPopup
  },
  data() {
    return {
      selected_property: null,
      show_properties: false,
      permissions_loading: false,
      googleSignInParams: {
        client_id: window.hkConfigEnvs.VUE_APP_GOOGLE_CLIENT_ID,
        hosted_domain: 'hotelkeyapp.com'
      },
      logout_loading: false,
      worker: null,
      heartbeatInterval: null,
      timesRemaining: null,
      meta: {
        senderId: null,
        appId: window.hkConfigEnvs.VUE_APP_NAME
      },
      extendInProgress: false,
      popupVisible: false,
      sessionInProgress: false,
      timeLeftSeconds: 0,
      workerTestInstance:null,
      routeStore: null,
      workerStore: null

    }
  },
  created() {
    this.routeStore = RouteStore()
    this.workerStore = useWorkerStore()
    localStorage.setItem('is_worker_enabled', is_sharedWorker_enabled(), this.user)
  },
  async mounted() {
    if (is_sharedWorker_enabled() && this.user) {
    this.initSharedWorker();
  }
    sessionStorage.removeItem('api_key')
    sessionStorage.removeItem('locale')
  // eslint-disable-next-line no-useless-assignment
  let token_expiry_dayjs_ob = null


    if (
      localStorage.getItem('hk_token_expiry')?.includes(':') ||
      localStorage.getItem('hk_token_expiry')?.includes('-') ||
      localStorage.getItem('hk_token_expiry')?.includes('Z') ||
      localStorage.getItem('hk_token_expiry')?.includes('T')
    ) {
      token_expiry_dayjs_ob = dayjs(localStorage.getItem('hk_token_expiry'))
    } else {
      token_expiry_dayjs_ob = dayjs(parseInt(localStorage.getItem('hk_token_expiry')))
    }

    if (dayjs().isAfter(token_expiry_dayjs_ob)) {
      this.activateLogout()
    }

    //setCookies(false);
    this.initializeSelectedProperty()
    this.loadProperties()
    if (!is_sharedWorker_enabled()) {
      LoginService.initializeRefreshTokenTrigger()
    }
        if(this.hasExternalLinksPermission){
            const { getTrainKeyExternalLinks } = await import('@hotelkeyrepo/hk-trainkey-vue-3/src/trainkey/services/trainkey-init.services.js');
            getTrainKeyExternalLinks();
          }

    this.getLocalization()
  },

  beforeUnmount() {
    console.log('this.user', this.user)


    clearInterval(this.heartbeatInterval);
  },
  computed: {
    ...mapState({
      user: (state) => state.current.user,
      hk_info: (state) => state.current.hk_info,
      //google_login: state => state.current.google_login,
      sso_login: (state) => state.current.sso_login,
      cognito_login: (state) => state.current.cognito_login,
      hashed_password: (state) => state.current.hashed_password,
      language: (state) => state?.current?.user?.language_code,
      isPopUpVisible: (state) => state.isPopupVisible,
      properties: (state) => state.current.properties,
      enterprise_permissions: (state) => state.current.enterprise_permissions
    }),
    hasExternalLinksPermission() {
    return checkPermission(
    this.enterprise_permissions,
    'ENTERPRISE_TRAINKEY_FIXED_LINKS',
    'READ_WRITE') || checkPermission(
      this.enterprise_permissions,
      'ENTERPRISE_TRAINKEY_FIXED_LINKS',
      'READ'
  )
    }
  },
  watch:{
    timeLeftSeconds(seconds){
      if(seconds != 0){
        this.popupVisible = true
      }else{
        this.popupVisible = false
      }
      this.timeleftSeconds = seconds
    }
  },
  methods: {
    initSharedWorker() {
      let workerVersion =   window.hkConfigEnvs.VUE_APP_SHARED_WORKRER_HASHNUMBER
            ? `?${window.hkConfigEnvs.VUE_APP_SHARED_WORKRER_HASHNUMBER}`
            : ''
    const workerUrl = `${window.hkConfigEnvs.VUE_APP_SHARED_WORKER_URL || window.origin}/shared/hotelKeySharedWorker.js${
      workerVersion
    }`;
    let localMAximumInactivityThreshold = window.hkConfigEnvs.MAXIMUM_INACTIVITY_THRESHOLD || null
    localStorage.setItem('maximum_inactivity_threshold', localMAximumInactivityThreshold);
    localStorage.setItem('worker_url_fallback', workerUrl);
    this.meta.senderId = ensureTabId();

    let current_properties = JSON.parse(JSON.stringify(this.properties));

    const meta = {
      senderId: this.meta.senderId,
      timestamp: Date.now(),
      appId: this.meta.appId,
      properties: current_properties || [],
      MAXIMUM_INACTIVITY_THRESHOLD: localMAximumInactivityThreshold,
    };

    const { workerInstance } =  useSharedWorkerSession(meta, {
      callLogout: this.callLogout,
      onReplyFromHome: this.onReplyFromHome,
      showPopup: this.showPopup,
      updateCountdown: this.updateCountdown,
      sendSessionProgressStatus: this.sendSessionProgressStatus,
      saveLatestTokenToStorage: this.saveLatestTokenToStorage,
      onRefreshToken: this.onRefreshToken,
      onTokenAck: this.onTokenAck,
      workerUrl
    });

    this.workerStore.saveWorkerInstance(workerInstance);
    this.workerStore.saveMainDatatoWorker(this.meta);
    this.worker = workerInstance.value;
    if (workerInstance && workerInstance.port) {
      this.workerTestInstance = workerInstance;
      const homeUrlBasedOnRouter = getHomeUrlFromRouterStrategy();
      console.log('setting url..')
      setHomeURL(homeUrlBasedOnRouter, meta);
    }
  },
  async callLogout() {
    const meta = {
        senderId: this.meta.senderId,
        timestamp: Date.now(),
        appId: window.hkConfigEnvs.VUE_APP_NAME
      }
    notifyDisconnect({ type: 'DISCONNECT', meta: meta, action: 'CLEAR_CONNECTIONS' })
    this.signOutApi().catch(() => {
          this.logout_loading = false
        });
  },

  onReplyFromHome(msg) {
    console.log('Message from home:', msg);
            if (this.$notify) {
              this.$notify.info({
                title: 'Message',
                message: msg
              });
            }
  },

  showPopup(payload) {
    this.popupVisible = payload.visible;
    this.timeLeftSeconds = payload.time_left_seconds;
  },

  updateCountdown(seconds) {
    this.timeLeftSeconds = seconds
  },

  sendSessionProgressStatus(value) {
    this.sessionInProgress = value
  },

  saveLatestTokenToStorage(token, token_expiry, senderId) {
    const meta = {
        senderId: this.meta.senderId,
        timestamp: Date.now(),
        appId: window.hkConfigEnvs.VUE_APP_NAME,
        properties: this.state.current.properties
      }
    if (senderId === sessionStorage.getItem('tab_id')) {
      localStorage.setItem('hk_token', token)
      localStorage.setItem('token_expiry', token_expiry)
      sendTokenAckToWorker(token, token_expiry, meta)
    }
  },

  onTokenAck (receiverID) {
    const meta = {
          senderId: this.meta.senderId,
          timestamp: Date.now(),
          appId: window.hkConfigEnvs.VUE_APP_NAME
        }
        console.log("receiverID",receiverID)
        console.log("this.meta.senderId",this.meta.senderId)

        if(receiverID === this.meta.senderId ){
          console.log('tab is sending final ack!!', this.meta.senderId)
              // add a callback function so we can know from that if receiverID ==== tab_id
              let token = localStorage.getItem('hk_token')
              let hk_token_expiry =  localStorage.getItem('hk_token_expiry')
              sendTokenAckToWorker(token, hk_token_expiry, meta);
            }
  },
  async onRefreshToken(payload, receiverId) {
    console.log('payload',payload)
    console.log('receiverId',receiverId)
    console.log('tabid', this.meta.senderId)

    if(receiverId === this.meta.senderId ){
      // only that active tab will call and save to localStorage!
      const meta = {
          senderId: this.meta.senderId,
          timestamp: Date.now(),
          appId: window.hkConfigEnvs.VUE_APP_NAME
        }
       let getResponse =  await refreshToken(payload,meta )
       console.log("getResponse",getResponse)
    }
  },

    sendMessage(targetAppId) {
      console.log("t", targetAppId)
      const meta = {
        senderId: this.meta.senderId,
        timestamp: Date.now(),
        appId: window.hkConfigEnvs.VUE_APP_NAME
      }
      sendMessageToApps(meta,targetAppId)
    },

    ...mapMutations([
      mutations.SET_CURRENT_TO_NULL,
      mutations.SET_CURRENT_PROPERTY,
      mutations.SET_CURRENT_BUSINESS_DAY,
      mutations.SET_DYNAMIC_URL,
      mutations.SET_PERMISSIONS,
      mutations.RESET_CURRENT_PROPERTY,
      mutations.SET_LOCALIZATION,
      mutations.SET_POPUP_VISIBLE
    ]),
    ...mapActions([actions.fetchProperties, actions.fetchActiveLanguages]),
    loadProperties() {
      if (!this.properties || this.properties.length === 0) {
        this.properties_list_loading = true
        this[actions.fetchProperties]()
          .catch((error) => {
            if (error?.response?.status === 403) {
              this.activateLogout()
            }
          })
          .finally(() => {
            this.properties_list_loading = false
          })
      }
    },
    activateLogout() {
      /* if (this.google_login) {
        this.googleLogout()
      } else {

      }*/

      this.logout()
    },
    async signOutApi() {
      console.log('calling signout..')
      let params = {}
      params = {
        redirect_url: this.cognito_login
          ? `${window.hkConfigEnvs.VUE_APP_LOGOUT_URL}&username=${this.user?.username}&state=HK_HOME`
          : window.hkConfigEnvs.VUE_APP_LOGOUT_URL
      }
      // const apiClient = axios.create({
      let baseURL = this.cognito_login
        ? `${window.hkConfigEnvs.VUE_APP_ENTERPRISE_URL}/${window.hkConfigEnvs.VUE_APP_CORE_API}/account/signout/cognito?username=${this.user?.username}`
        : `${window.hkConfigEnvs.VUE_APP_ENTERPRISE_URL}/${window.hkConfigEnvs.VUE_APP_CORE_API}/account/signout`
      // withCredentials: false, // this is the default
      let headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'hk-token': localStorage.getItem('hk_token'),
        'hk-info': this.hk_info,
        'hk-app-id': 'HK_HOME',
        'hk-app-version': window.hkConfigEnvs.VUE_APP_VERSION,
        Authorization: this.cognito_login ? localStorage.getItem('hk_token') : null,
        'hk-session-id': getCookie('hk_session_id')
      }
      // params: params
      //  });
      if (this.cognito_login) {
        if (window.location.hostname === 'localhost') {
          return axios
            .get(baseURL, {}, { params: params, headers: headers })
            .then((res) => {
              this.clearData(res.status, params.redirect_url)
            })
            .catch((error) => {
              this.clearData(error.response?.status, params.redirect_url)
            })
        } else {
          /**
           * EA-27496
           */
          return axios
            .get(baseURL, { params: params, headers: headers })
            .then((res) => {
              this.clearData(res.status, params.redirect_url)
            })
            .catch((error) => {
              this.clearData(error.response?.status, params.redirect_url)
            })

          /**
           * end of EA-27496
           */

          //this.clearData(null, params.redirect_url)
        }
      } else {
        return axios
          .post(baseURL, {}, { params: params, headers: headers })
          .then((res) => {
            this.clearData(res.status, params.redirect_url)
          })
          .catch((error) => {
            this.clearData(error.response?.status, params.redirect_url)
          })
      }
    },
    logout() {
      this.logout_loading = true;
      if (is_sharedWorker_enabled()) {
        const meta = {
          senderId: this.meta.senderId, timestamp: Date.now(), appId: this.meta.appId

        }
        requestLogout(meta)
        notifyDisconnect({ type: 'DISCONNECT', meta: { senderId: this.meta.senderId, timestamp: Date.now(), appId: this.meta.appId }, action: "DELETE_TABS" })
        notifyDisconnect({ type: 'DISCONNECT', meta: { senderId: this.meta.senderId, timestamp: Date.now(), appId: this.meta.appId }, action: "CLEAR_CONNECTIONS" })

      } else {
        this.signOutApi().catch(() => {
          this.logout_loading = false
        });
      }
    },
    googleLogout() {
      window.gapi.load('auth2', async () => {
        let initSignOut = await window.gapi.auth2.init(this.googleSignInParams)
        initSignOut.signOut().then(() => {
          this.signOutApi()
          // this.clearData()
        })
        initSignOut.disconnect()
      })
    },
    clearData(status, redirect_url) {
      let cognito_login = this.cognito_login
      this[mutations.SET_CURRENT_TO_NULL]()
      clearLocalStorage()
      clearAllCookies()

        if (window.location.hostname !== 'localhost' && window.hkConfigEnvs.VUE_APP_LOGOUT_URL) {
          window.location.href = redirect_url
        } else {
          this.routeStore.hkRouterPush({ name: cognito_login ? 'different-login' : 'loginWithSlash' })
        }
    },
    getPermissions(propertyId) {
      let newToken
      let newInfo

      if (this.google_login || this.sso_login || this.cognito_login) {
        newToken = localStorage.getItem('hk_token')
        newInfo = this.hk_info
      } else {
        let token = Security.getTokenWithHashedPass(this.user.username, this.hashed_password)

        newToken = token.token
        newInfo = token.info
      }

      const tokenHeader = hkTokenOrBearerToken(newToken)

      const apiClient = axios.create({
        baseURL: `${window.hkConfigEnvs.VUE_APP_ENTERPRISE_URL}/${window.hkConfigEnvs.VUE_APP_CORE_API}/${window.hkConfigEnvs.VUE_APP_ENTERPRISE_IDENTIFIER}/properties/${propertyId}/permissions`,
        withCredentials: false,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          ...tokenHeader,
          'hk-info': newInfo,
          'hk-app-id': 'HK_HOME',
          'hk-app-version': window.hkConfigEnvs.VUE_APP_VERSION,
          'hk-session-id': getCookie('hk_session_id')
        }
      })

      return apiClient.get('/')
    },
    chooseProperty(property) {

      if (!property.region?.url) {
        this.$notify.error({
          title: 'Dynamic URL',
          message: 'Dynamic URL from property is empty: ' + property.region.url
        })
      } else {
        this[mutations.SET_DYNAMIC_URL](property.region.url)
      }

      const getTab = sessionStorage.getItem('tab_id')
      if (getTab) {
        setCurrentTab(getTab)
      }

      this.permissions_loading = true
      this.getPermissions(property.id)
        .then((res) => {
          this[mutations.SET_PERMISSIONS](res.data)
          this[mutations.SET_CURRENT_PROPERTY](property)
          setCookies(false)
          this.selected_property = property
          localStorage.setItem('current_property', JSON.stringify(this.selected_property))
        })
        .catch((error) => {
          if (error.response?.status === 403) {
            this.activateLogout()
          }
        })
        .finally(() => {
          this.permissions_loading = false
        })
    },
    deSelectProperty() {
      this.selected_property = null
      this[mutations.RESET_CURRENT_PROPERTY]()
      localStorage.removeItem('current_property')
      //deleteAllCookiesFromAllPaths();
      setCookies(false)
    },
    handleSessionExtend() {
      console.log('Extend session clicked');
      const meta = {
        senderId: this.meta.senderId,
        timestamp: Date.now(),
        appId: this.meta.appId
      }
      userRequestedExtend(meta)
    },

    getLocalization() {
      this.permissions_loading = true
      if(!this.language) return
      Global.getLocalization(this.language)
        .then((res) => res.data)
        .then(async (localizations) => {
          this.permissions_loading = false
          this[mutations.SET_LOCALIZATION](localizations)
          let user_language = this.language.substring(0, 2)
          this.$i18n.locale = user_language
          this.$i18n.setLocaleMessage(user_language, localizations)
          initDataLog({ user: this.user, property: null })
        })
        .catch((err) => {
          this.$notify.error({
            title: 'Error',
            message: err.response
              ? err.response.data
                ? err.response.data.message
                : err.response
              : err
          })
          this.permissions_loading = false
        })
    },
    initializeSelectedProperty() {
      try {
        const raw = localStorage.getItem('current_property')
        const property = JSON.parse(raw)
        this.selected_property = property
      } catch (error) {
        console.warn('Failed to parse current_property:', error)
        this.selected_property = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$blue: #46a0fc;

.home {
  height: 100vh;
  overflow: hidden;
  position: relative;

  .el-main {
    height: calc(100% - 60px);
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    padding-right: 0;

    .content {
      flex: 3;
      margin: 0 0 1rem 0;
      overflow: auto;
      height: calc(100% - 1rem);

      .loading {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          animation: rotate linear 3s infinite;
        }
      }
    }
  }

  .blue-color {
    color: $blue;
  }
}

@media (max-width: 768px) and (min-width: 420px) {
  .home {
    .el-main {
      .content {
        flex: 2;
      }
    }
  }
}

@media (max-width: 420px) {
  .home {
    overflow: visible;
    height: auto;
    position: relative;

    .el-main {
      flex-direction: column;
      overflow: visible;
      height: auto;

      .content {
        height: auto;
        overflow: visible;
        margin: 20px 0 0 0;
      }
    }
  }
}

// loader animaiton
.is-loading {
  animation: spin 3s linear infinite;
  display: flex;
  height: 100vh;
  margin: 0 auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.demo-box{
  display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.demo-buttons {
  display: flex;
  justify-content: center;
  text-align: center;

  button {
    margin-bottom: 5px;
  }
}
</style>
